export async function ptlGetLabelUseCase(data, shipmentRepository) {
    
    const result = await shipmentRepository.ptl_get_label(data);

    return result;
}